var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Admin")]),_c('h2',[_vm._v(_vm._s(_vm.me))]),_c('a',{attrs:{"href":"/"},on:{"click":function($event){$event.preventDefault();return _vm.logout($event)}}},[_vm._v("Logout")])])}
var staticRenderFns = []

export { render, staticRenderFns }